import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ValidationIssue {
  item_id: string;
  item_name: string;
  issue: 'missing_applicant' | 'missing_payer' | 'missing_poc' | 'missing_eligibility';
  message: string;
  severity: 'error' | 'warning';
}

export function useDealValidation(dealId?: string) {
  const { data: issues = [], isLoading, refetch } = useQuery({
    queryKey: ['deal-validation', dealId],
    queryFn: async () => {
      if (!dealId) return [];
      
      const { data, error } = await supabase
        .rpc('validate_deal_for_closing', { p_deal_id: dealId });

      if (error) throw error;
      
      // O resultado é um array JSON, precisamos fazer cast
      return (data as unknown as ValidationIssue[]) || [];
    },
    enabled: !!dealId,
  });

  const canClose = issues.length === 0;
  const errorCount = issues.filter(i => i.severity === 'error').length;
  const warningCount = issues.filter(i => i.severity === 'warning').length;

  return {
    issues,
    isLoading,
    canClose,
    errorCount,
    warningCount,
    revalidate: refetch,
  };
}
